import { pipe } from 'fp-ts/function';
import { CashierFilterParameters, CashierResult, useRepositoryQuery } from '@mews-commander/data-access';
import { transformCashiers } from '../utils';

export const selectCashierData = (data: CashierResult) => {
    const cashiers = data.cashiers || [];
    const cashierAssignments = data.cashierAssignments || [];
    const profiles = Object.fromEntries(data.profiles?.map((profile) => [profile.id, profile]) || []);
    return pipe(cashiers, transformCashiers(cashierAssignments, profiles));
};

export const useCashierData = (filters: CashierFilterParameters, enabled: boolean) =>
    useRepositoryQuery('cashiers', 'getAll', filters, {
        select: selectCashierData,
        enabled,
    });
